import { useState, useEffect } from 'react';
import axios from 'axios';
import IkiSymbol from '@/components/IkiSymbol';
import '@/styles/Philosophy.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function Philosophy() {
  const [userLang, setUserLang] = useState('en');
  const [manifesto, setManifesto] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      const userEmail = localStorage.getItem('userEmail');
      
      // Get user language
      if (userEmail) {
        const userResponse = await axios.get(`${API}/users/${userEmail}`);
        setUserLang(userResponse.data.language || 'en');
      }
      
      // Get manifesto
      const lang = userEmail ? (await axios.get(`${API}/users/${userEmail}`)).data.language || 'en' : 'en';
      const manifestoResponse = await axios.get(`${API}/content/manifesto?key=central-vision&lang=${lang}`);
      setManifesto(manifestoResponse.data);
    } catch (error) {
      console.error('Error loading content:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="page-container" style={{ textAlign: 'center', padding: '100px 20px' }}>
        <div className="loading"></div>
      </div>
    );
  }

  return (
    <div className="philosophy-container" data-testid="philosophy-page">
      <div className="philosophy-content">
        <div className="philosophy-header">
          <h1>Philosophy</h1>
          <p className="subtitle">Who We Are</p>
        </div>

        {manifesto && (
          <div className="manifesto-text">
            {manifesto.text.split('\n\n').map((paragraph, index) => (
              <p key={index} className="manifesto-paragraph">
                {paragraph}
              </p>
            ))}
          </div>
        )}

        <div className="philosophy-footer" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
          <p className="signature">- HYPSEYA</p>
          <IkiSymbol name="growth" size="sm" ariaLabel="Growth" />
        </div>
      </div>
    </div>
  );
}

export default Philosophy;